





























































import Card from "@/components/layout/card.vue";
import { ComponentInstance, defineComponent, ref } from "@vue/composition-api";
import Page from "@/components/layout/page.vue";
import PageHeader from "@/components/navigation/page-header.vue";
import { useRouter } from "@/router/router";
import { useCommittable } from "@/composables/committable";
import { Floor } from "@/swagger/models";
import { floorService } from "@/services/floor";
import ZonesTable from "@/components/tables/zones-table.vue";
import { useTosti } from "@/plugins/vuetify-tosti";
import CommitResetBar from "@/components/data/commit-reset-bar.vue";
import TabsFloor from "@/components/tabs/floor.vue";
import Alert from "@/components/misc/alert.vue";
export default defineComponent({
    name: "floors",
    props: {},
    components: { Card, TabsFloor, CommitResetBar, Page, PageHeader, ZonesTable, Alert },
    setup(props, context) {
        const tosti = useTosti();
        const loading = ref(true);
        const floor = ref<Floor>();
        const { route, router } = useRouter(context);

        const floorplanFileInput = ref<ComponentInstance>();

        const { clone, commit, revert, isDirty } = useCommittable<Floor>({
            originalValue: floor,
            watchOriginal: true,
            async onCommit() {
                try {
                    loading.value = true;

                    if (clone.value.id) {
                        return await floorService.patch(floor.value.id, clone.value);
                    } else {
                        const floor = await floorService.create(clone.value);
                        await router.replace({ params: { floorId: floor.id.toString() } });
                        return floor;
                    }
                } catch (e) {
                    // The service will have handled showing a toast at this point
                    // console.warn(e);
                } finally {
                    loading.value = false;
                }
            },
        });

        (async () => {
            if (route.value.params.floorId !== "new") {
                floor.value = await floorService.get(parseInt(route.value.params.floorId));
            } else {
                floor.value = await floorService.build({
                    // @ts-ignore
                    office: parseInt(route.value.params.officeId),
                });
            }

            revert(true);
            loading.value = false;
        })();

        const floorplanFile = ref<File>();
        const uploadFloorplan = async () => {
            if (!floorplanFile.value) {
                // return tosti.warning({ message: "Please select an image to upload" });
                floorplanFileInput.value.$el.querySelector("input").click();
                return;
            }
            const updatedFloor = await floorService.uploadFloorplan(floor.value.id, floorplanFile.value);
            floorplanFile.value = null;
            floor.value.floorplanUrl = updatedFloor.floorplanUrl;
        };

        const deleteFloor = async () => {
            if (!floor.value.id) return; //
            if (!confirm("Are you sure you want to delete this floor?")) return;
            await floorService.delete(floor.value.id);
            await router.replace({ name: "floors" });
        };

        return {
            loading,
            floor,
            clone,
            commit,
            revert,
            isDirty,
            floorplanFile,
            uploadFloorplan,
            deleteFloor,
            floorplanFileInput,
        };
    },
});
